// src/data/events.js
export const CITIES = [
  "Cape Town","Johannesburg","Nairobi","Lagos",
  "London","New York","Dubai","Accra","Durban","Dakar"
];

export const CAT_COLOR = {
  concert: "#7F77DD",
  party:   "#D85A30",
  sports:  "#1D9E75",
  food:    "#D4537E",
  outdoor: "#EF9F27",
  wellness:"#5DCAA5",
  culture: "#378ADD",
  festival:"#BA7517",
};

export const SEED_EVENTS = [
  {
    id:"jazz", title:"Cape Town Jazz Festival", cat:"concert", city:"Cape Town",
    date:"Apr 25–26", time:"2 PM – 12 AM", venue:"CTICC", price:450, priceLabel:"From R450",
    crowd:"5 000+", grad:"linear-gradient(135deg,#534AB7,#D4537E)", color:"#7F77DD",
    highlights:["40+ artists","3 stages","Food village","Jazz masterclasses"],
    vibes:["World class","Multi-stage","Iconic"],
    lineup:[{name:"Hugh Masekela Tribute",time:"5 PM"},{name:"Simphiwe Dana",time:"7 PM"},{name:"Black Coffee",time:"9 PM"}],
    lat:51, lng:44, live:false, rating:4.8, ratingCount:134,
  },
  {
    id:"afro", title:"Afrobeats Rooftop Party", cat:"party", city:"Cape Town",
    date:"Tonight", time:"9 PM – 3 AM", venue:"Signal Hill", price:250, priceLabel:"R250",
    crowd:"200", grad:"linear-gradient(135deg,#D85A30,#BA7517)", color:"#D85A30",
    highlights:["Open bar","City views","Live DJ","Dress code"],
    vibes:["High energy","City views","Amapiano"],
    lineup:[{name:"DJ Maphorisa",time:"9 PM"},{name:"Uncle Waffles",time:"11 PM"}],
    lat:25, lng:62, live:true, rating:4.6, ratingCount:47,
  },
  {
    id:"stormers", title:"Stormers vs Lions – URC", cat:"sports", city:"Cape Town",
    date:"Apr 20", time:"5:05 PM", venue:"DHL Newlands", price:150, priceLabel:"From R150",
    crowd:"40 000", grad:"linear-gradient(135deg,#1D9E75,#185FA5)", color:"#1D9E75",
    highlights:["Top URC match","Giant screens","Braai area","Family zone"],
    vibes:["Stadium energy","Family friendly","Big atmosphere"],
    lineup:[], lat:62, lng:78, live:false, rating:4.5, ratingCount:203,
  },
  {
    id:"kirstenbosch", title:"Kirstenbosch Summer Concert", cat:"concert", city:"Cape Town",
    date:"Apr 27", time:"5:30 PM", venue:"Kirstenbosch Gardens", price:220, priceLabel:"R220",
    crowd:"1 500", grad:"linear-gradient(135deg,#3B6D11,#0F6E56)", color:"#1D9E75",
    highlights:["Lawn picnic","Wine & food","Mountain backdrop","BYO blankets"],
    vibes:["Relaxed","Picnic vibes","Scenic"],
    lineup:[{name:"Goldfish",time:"5:30 PM"},{name:"Jeremy Loops",time:"7:30 PM"}],
    lat:72, lng:28, live:false, rating:4.9, ratingCount:89,
  },
  {
    id:"openmic", title:"Open Mic Night – The Assembly", cat:"concert", city:"Cape Town",
    date:"Tonight", time:"8 PM – 11 PM", venue:"De Waterkant", price:0, priceLabel:"Free",
    crowd:"100", grad:"linear-gradient(135deg,#D4537E,#534AB7)", color:"#D4537E",
    highlights:["Free entry","Local talent","Craft beer bar","Sign up to perform"],
    vibes:["Intimate","Chill","Free"], lineup:[], lat:35, lng:55, live:true, rating:4.7, ratingCount:62,
  },
  {
    id:"va", title:"V&A Waterfront Market", cat:"food", city:"Cape Town",
    date:"Today", time:"9 AM – 8 PM", venue:"V&A Waterfront", price:0, priceLabel:"Free",
    crowd:"Open air", grad:"linear-gradient(135deg,#D4537E,#D85A30)", color:"#D4537E",
    highlights:["80+ vendors","Live acoustic","Craft beer","Artisan goods"],
    vibes:["Family","Waterfront","Food & craft"], lineup:[], lat:45, lng:72, live:true, rating:4.3, ratingCount:198,
  },
  {
    id:"yoga", title:"Sunset Yoga – Camps Bay", cat:"wellness", city:"Cape Town",
    date:"Today", time:"6 PM – 7:30 PM", venue:"Camps Bay Beach", price:120, priceLabel:"R120",
    crowd:"30", grad:"linear-gradient(135deg,#5DCAA5,#85B7EB)", color:"#5DCAA5",
    highlights:["Ocean backdrop","Certified instructor","Mat rental","Golden hour"],
    vibes:["Mindful","Outdoor","Sunset"], lineup:[], lat:78, lng:35, live:false, rating:4.8, ratingCount:41,
  },
  {
    id:"hike", title:"Signal Hill Sunrise Hike", cat:"outdoor", city:"Cape Town",
    date:"Tomorrow", time:"6 AM – 8 AM", venue:"Signal Hill", price:0, priceLabel:"Free",
    crowd:"Open trail", grad:"linear-gradient(135deg,#EF9F27,#D85A30)", color:"#EF9F27",
    highlights:["Panoramic views","Guided group","Coffee stop","All fitness levels"],
    vibes:["Active","Scenic","Social"], lineup:[], lat:22, lng:30, live:false, rating:4.6, ratingCount:55,
  },
];

export const SEED_COMMENTS = {
  jazz:[
    {id:1,user:"Kai M",av:"KM",bg:"#EEEDFE",tc:"#534AB7",stars:5,text:"Absolutely electric — lineup incredible from start to finish!",time:"2h ago",likes:24,liked:false},
    {id:2,user:"Lena N",av:"LN",bg:"#FBEAF0",tc:"#993556",stars:5,text:"Third year in a row and it keeps getting better. Food village was a highlight.",time:"5h ago",likes:18,liked:false},
  ],
  afro:[
    {id:3,user:"Zara P",av:"ZP",bg:"#FAEEDA",tc:"#633806",stars:5,text:"Best rooftop party in Cape Town. Views were unreal.",time:"Last week",likes:31,liked:false},
    {id:4,user:"Dom K",av:"DK",bg:"#E6F1FB",tc:"#185FA5",stars:5,text:"Open bar was generous, DJ set was fire.",time:"Last week",likes:22,liked:false},
  ],
  stormers:[{id:5,user:"Kai M",av:"KM",bg:"#EEEDFE",tc:"#534AB7",stars:5,text:"Incredible atmosphere. Braai area was a great touch.",time:"3 weeks ago",likes:44,liked:false}],
  kirstenbosch:[{id:6,user:"Zara P",av:"ZP",bg:"#FAEEDA",tc:"#633806",stars:5,text:"Magical evening. Nothing beats a mountain backdrop at sunset.",time:"1 month ago",likes:56,liked:false}],
  openmic:[], va:[], yoga:[], hike:[],
};

export const TICKET_TIERS = {
  jazz:[
    {name:"General Admission",price:450,desc:"Access to all 3 stages"},
    {name:"VIP Lounge",price:950,desc:"Exclusive lounge + backstage"},
    {name:"Weekend Pass",price:799,desc:"Both days, all stages"},
  ],
  stormers:[
    {name:"General Stand",price:150,desc:"Open seating"},
    {name:"Grandstand",price:280,desc:"Premium covered seating"},
    {name:"Family Pack (×4)",price:480,desc:"4 tickets + braai voucher"},
  ],
  kirstenbosch:[
    {name:"Lawn Ticket",price:220,desc:"Garden + concert entry"},
    {name:"Premium Picnic Spot",price:380,desc:"Reserved spot + welcome wine"},
  ],
};

export const FRIENDS = [
  {av:"KM",bg:"#EEEDFE",tc:"#534AB7",name:"Kai Mokoena",status:"is going to Afrobeats Rooftop Party",time:"2h ago",eventId:"afro"},
  {av:"LN",bg:"#FBEAF0",tc:"#993556",name:"Lena Nkosi",status:"saved Cape Town Jazz Festival",time:"3h ago",eventId:"jazz"},
  {av:"TN",bg:"#E1F5EE",tc:"#0F6E56",name:"Thabo Ndlovu",status:"bought tickets to Stormers vs Lions",time:"5h ago",eventId:"stormers"},
  {av:"ZP",bg:"#FAEEDA",tc:"#633806",name:"Zara Petersen",status:"reviewed Kirstenbosch Concert ★★★★★",time:"Yesterday",eventId:"kirstenbosch"},
];
